import { SectionHead, Reveal } from "./Reveal";
import { useContent } from "@/context/ContentContext";

const STEPS = [
  {
    nr: "01",
    title: "Wunschtermin anfragen",
    text: "Online über das Formular oder direkt telefonisch – du wählst Datum und Leistung.",
  },
  {
    nr: "02",
    title: "Wir kommen zu dir",
    text: "Komplett mobil vor Ort: zu Hause, auf der Arbeit oder wo dein Auto gerade steht.",
  },
  {
    nr: "03",
    title: "Aufbereitung vor Ort",
    text: "Profi-Equipment, geprüfte Pflegemittel und viel Liebe zum Detail in deinem Innenraum.",
  },
  {
    nr: "04",
    title: "Ergebnis genießen",
    text: "Hygienisch sauber, duftend frisch – und beim Blick auf die Sitze kommen Erstaunte-Blicke.",
  },
];

export default function Process() {
  const c = useContent();
  return (
    <section id="ablauf" data-testid="process-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          eyebrow={c.texts.process_eyebrow}
          title={c.texts.process_title}
          sub={c.texts.process_sub}
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.nr} delay={i * 0.08} className="h-full">
              <div className="relative h-full rounded-2xl border border-[#27272A] bg-[#121215] p-7 transition-colors hover:border-blue-500/40">
                <span className="font-mono text-4xl font-bold text-zinc-800">{s.nr}</span>
                <h3 className="mt-6 font-display text-lg font-semibold text-zinc-100">{s.title}</h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
                {i < STEPS.length - 1 && (
                  <span className="absolute top-9 -right-3 hidden lg:block font-mono text-blue-400/60 text-lg">→</span>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
